import React, {useState} from 'react';
import {ActionPlanItemDrawer} from 'src/component/modal/ActionPlanItemDrawer';

import {CategoryKeyEnum} from '#apollo/schema';
import {ModalRoot} from '#component/base/Modal';
import {ActionPlanPage} from '#component/page/ActionPlan/ActionPlan.types';
import * as css from '#component/partial/ActionPlanGoals/ActionPlanGoals.css';
import {GoalsBody} from '#component/partial/ActionPlanGoals/components/GoalsBody';
import {GoalsListItem} from '#component/partial/ActionPlanGoals/components/GoalsList/GoalsListItem';

interface GoalsListProps {
  goals: ActionPlanPage.ActionPlanAdjustment[];
  surveySubmissionId?: string;
}
function GoalsList({goals, surveySubmissionId}: GoalsListProps) {
  const [modalGoalOpened, setModalGoalOpened] = useState<boolean>(false);
  const [selectedGoal, setSelectedGoal] = useState<ActionPlanPage.ActionPlanAdjustment>();
  const handleGoalClick = (goal: ActionPlanPage.ActionPlanAdjustment) => {
    setSelectedGoal(goal);
    setModalGoalOpened(prev => !prev);
  };

  if (!goals?.length) return null;
  return (
    <div>
      <ul className={css.accordionList}>
        {goals.map(goal => (
          <li key={goal.id} className={css.accordionItem}>
            <GoalsListItem
              key={goal.id}
              title={goal?.healthFactorAssessment?.healthFactor?.title || ''}
              subtitle={goal?.recommendedResponse}
              categoryKey={
                goal?.healthFactorAssessment?.categoryAssessment?.category?.key ||
                CategoryKeyEnum.Research
              }
              impactLevel={goal?.impactLevel || undefined}
              imageUrl={goal?.healthFactorAssessment?.healthFactor?.imageUrl || ''}
              onClick={() => handleGoalClick(goal)}
            />
          </li>
        ))}
      </ul>

      <ModalRoot open={modalGoalOpened} onOpenChange={() => setModalGoalOpened(false)}>
        {selectedGoal && (
          <ActionPlanItemDrawer
            title={selectedGoal?.healthFactorAssessment?.healthFactor?.title || ''}
            subtitle={selectedGoal?.recommendedResponse}
            categoryKey={
              selectedGoal?.healthFactorAssessment?.categoryAssessment?.category?.key ??
              CategoryKeyEnum.Research
            }
            impactLevel={selectedGoal?.impactLevel || undefined}
            imageUrl={selectedGoal?.healthFactorAssessment?.healthFactor?.imageUrl || ''}>
            <GoalsBody
              surveySubmissionId={surveySubmissionId}
              healthFactorAssessment={selectedGoal?.healthFactorAssessment}
              benefits={selectedGoal?.healthFactorAssessment?.healthFactor?.benefits ?? ''}
              tips={selectedGoal?.healthFactorAssessment?.healthFactor?.tips ?? ''}
              impactLevel={selectedGoal?.impactLevel}
            />
          </ActionPlanItemDrawer>
        )}
      </ModalRoot>
    </div>
  );
}

export {GoalsList};
